import React from "react";
import HistoryPresenter from "./HistoryPresenter";
import { useScrollTop } from '../../hooks';

const HistoryContainer = () => {
  useScrollTop();
  return <HistoryPresenter />;
};

export default HistoryContainer;
